import React, { useContext } from "react";
import { Box } from "@chakra-ui/react";
import NavigationLabel from "./NavigationLabel";
import { useLocation } from "react-router-dom";
import { sendTrackingEvent } from "../utils/gtm";

import { AppContext } from "../../../context/ApplicationContext";
interface Props {
  height: string | number;
  tabsLabelsList: {
    key: number | string;
    title: string | number;
    type: "primary" | "secondary" | "tab" | "hamburger-label";
    iconForTab?: React.ReactElement; // required if type is tabs
    path: string;
  }[];
}

const BottomTabNavbar = ({ tabsLabelsList, height }: Props) => {
  const location = useLocation();
  const state = useContext(AppContext)[0];

  const handleSendEvent = (title: string | number) => {
    switch (title) {
      case "Courses":
        sendTrackingEvent({ event: "dash-courses", eventLabel: location.pathname });
        break;
      case "Contests":
        sendTrackingEvent({ event: "dash-contests", eventLabel: location.pathname });
        break;
      case "Events" || "Events & Contests":
        sendTrackingEvent({ event: "dash-events", eventLabel: location.pathname });
        break;
      case "Self learning":
        sendTrackingEvent({ event: "dash-self_learning", eventLabel: location.pathname });
        break;
      default:
        return;
    }
  };
  return (
    <Box
      boxShadow="0px -1px 0px 0px #D9D9D9"
      d={{ base: "flex", md: "none" }}
      bg={"white"}
      h={height}
      borderTop="1px solid #D9D9D9"
    >
      {tabsLabelsList.map((label) => (
        <Box
          key={label.key}
          w={"100%"}
          onClick={() => {
            handleSendEvent(label.title);
          }}
          id={label.key === 2 ? "contest-nav-mobile" : ""}
          display={label.path.includes("contests") ? "none" : "block"}
        >
          <NavigationLabel
            title={label.title}
            type={label.type}
            iconForTab={label.iconForTab}
            active={label.path === location.pathname}
            path={label.path}
          />
        </Box>
      ))}
    </Box>
  );
};

export default BottomTabNavbar;
